import pTimeout from "@-/com.npmjs.p-timeout";
import { watchAsyncStep } from "@-/dev.improve.haniverse.lib.async-watchdog";

export const LEARNING_STATS_QUERY_STEP_DEADLINE_MS = 8000;

/**
 * Observe and bound one database dependency of the Stats page.
 *
 * The watchdog reports the dependency name after three seconds. The deadline then
 * converts a promise that never settles into an ordinary query failure, allowing
 * the page's retryable error boundary to replace its Suspense spinner.
 */
export function runLearningStatsQueryStep<T>(
  stepName: string,
  step: () => Promise<T>,
  deadlineMs = LEARNING_STATS_QUERY_STEP_DEADLINE_MS,
): Promise<T> {
  return watchAsyncStep(`learningStats: ${stepName}`, () =>
    pTimeout(step(), {
      message: Object.assign(
        new Error(`Learning Stats dependency "${stepName}" did not settle within ${deadlineMs}ms`),
        { name: "LearningStatsQueryStepDeadlineError" },
      ),
      milliseconds: deadlineMs,
    }),
  );
}
